'use strict';

import ngResource from 'angular-resource';

class SaConfigNotifyListService {
    constructor($resource) {
        'ngInject';
        this.api = $resource(
            '/api/sa_config_notify_list/:id', { id: '@id' },
            { 
                show:   { method: 'GET', isArray: false },
                update: { method: 'PUT', isArray: false }
            }
        );
    }
}

export default angular.module('leptonApp.SaConfigNotifyListService', ['ngResource'])
    .service('SaConfigNotifyListService', ['$resource', SaConfigNotifyListService])
    .name;



// WEBPACK FOOTER //
// ./public/dev/components/api/sa_config_notify_list/sa_config_notify_list.service.js